import debounce from 'lodash.debounce';

type ReturnType = {
  addListener: () => void;
  removeListener: () => void;
};

export const listenForViewportChange = (callback: () => void): ReturnType => {
  const viewport =
    (window.visualViewport as VisualViewport | undefined) ?? window;
  const debouncedCallback = debounce(callback, 200);

  const addListener = (): void => {
    viewport.addEventListener('resize', debouncedCallback);
    window.addEventListener('resize', debouncedCallback);
  };

  const removeListener = (): void => {
    viewport.removeEventListener('resize', debouncedCallback);
    window.removeEventListener('resize', debouncedCallback);
    debouncedCallback.cancel?.();
  };

  return {
    addListener,
    removeListener,
  };
};
